import { PresetOption } from '../../types';
import { ActiveDateField } from '../../utils/dateRange';

export enum CUSTOM_DATE_INPUT_NAME {
  START_DATE_RANGE = 'start-date-range',
  END_DATE_RANGE = 'end-date-range',
  START_DATE_COMPARISON = 'start-date-comparison',
  END_DATE_COMPARISON = 'end-date-comparison',
}

export interface DateInputsProps {
  onChange: (
    from: Date | undefined,
    to: Date | undefined,
    presetValue: string,
    presetOptions: PresetOption[],
    event?: React.ChangeEvent<Element>
  ) => void;
  from?: Date;
  to?: Date;
  today: Date;
  onValidate: ({ from, to }: { from: Date; to: Date }) => void;
  validationData: { from: string; to: string; type: string };
  readOnly?: boolean;
  readOnlyTo?: boolean;
  disabledDates: (date: Date) => boolean;
  activeField: ActiveDateField;
  rangeKey: 'range' | 'comparison';
  onFocus: (field: 'start' | 'end', range: 'range' | 'comparison') => void;
}
